
import { Components, Theme } from "@mui/material";
import { CustomPalette } from "./palette";

export default {
  MuiChip: {
    styleOverrides: {
      sizeSmall: {
        padding: "0 8px",
        '& .MuiChip-label': {
          fontSize: "10px",
          fontWeight: 500,
          textTransform: "uppercase",
        },
        '& .MuiChip-icon': {
          fontSize: "14px",
        }
      },
      colorInfo: {
        backgroundColor: CustomPalette.pink.secondary,
        '& .MuiChip-label, & .MuiChip-icon': {
          color: CustomPalette.pink.main,
        }
      },
      colorWarning: {
        backgroundColor: CustomPalette.warning.secondary,
        '& .MuiChip-label, & .MuiChip-icon': {
          color: CustomPalette.warning.main,
        }
      },
      colorSuccess: {
        backgroundColor: CustomPalette.success.secondary,
        '& .MuiChip-label, & .MuiChip-icon': {
          color: CustomPalette.success.main,
        }
      }
    }
  }
} as Components<Omit<Theme, "components">>;